import {FunctionComponent} from 'react';
import SectionSubtitle from '@/components/section-subtitle';
import SectionTitle from '@/components/section-title';

const Titles: FunctionComponent = () => {
  return (
    <div className="flex flex-col gap-5">
      <SectionTitle>Retenue d’impôt</SectionTitle>

      <SectionSubtitle>Provenance des fonds</SectionSubtitle>
    </div>
  );
};

export default Titles;
